import React from 'react';
import { publish } from '@wh/message-bus';
import './ActionArea.scss';

import { SearchIcon } from './SearchIcon';
import { LoginButton } from './buttons/Login';
import { RegistrationButton } from './buttons/Registration';
import { DepositButton } from './buttons/Deposit';


export const ActionArea = ({ content, buildVertical, buttonVisibility }) => {

  const {
    loginButtonVisible,
    registrationButtonVisible,
    depositButtonVisible
  } = buttonVisibility;

  const searchClicked = () => {
    if (buildVertical?.startsWith('sportsbook')) {
      publish('search.open');
    } else {
      publish('wh.common.event.ui.header.search.clicked');
    }
  }

  const showSearch = buildVertical === 'gaming' 
    || buildVertical === 'casino' 
    || buildVertical?.startsWith('sportsbook');

  return <div className="sb-header__section sb-header__section--align-right" data-test-id="header.slot-actions">
      {loginButtonVisible && <LoginButton label={content?.['login-button']}/>}
      {registrationButtonVisible && <RegistrationButton label={content?.['registration-button']} />}
      {depositButtonVisible && <DepositButton label={content?.['deposit-button']} />}
      <div className="sb-header__item">
        <div id='cp-ma-wrapper'></div>
      </div>
      {showSearch && <div className="sb-header__item">
        <button className='sb-header-search' onClick={searchClicked}>
          <SearchIcon />
        </button>
      </div>}
    </div>;
}
